import React, { useEffect, useState } from "react";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../firebase";
import "./LinkPreviewCard.css";

// Browsers can't fetch arbitrary third-party pages (CORS), so the Open Graph
// scrape runs server-side in the fetchLinkPreview callable; this mirrors the
// mobile LinkPreview card. Session cache keeps each URL to one round trip.
const fetchLinkPreview = httpsCallable(functions, "fetchLinkPreview");
const ogCache = new Map(); // url -> { title, description, image } | null

export default function LinkPreviewCard({ url, mine }) {
  const [data, setData] = useState(ogCache.has(url) ? ogCache.get(url) : undefined);

  useEffect(() => {
    if (ogCache.has(url)) { setData(ogCache.get(url)); return; }
    let alive = true;
    fetchLinkPreview({ url })
      .then((res) => {
        const og = res.data && (res.data.title || res.data.image) ? res.data : null;
        ogCache.set(url, og);
        if (alive) setData(og);
      })
      .catch(() => { ogCache.set(url, null); if (alive) setData(null); });
    return () => { alive = false; };
  }, [url]);

  if (!data) return null;

  let domain = url;
  try { domain = new URL(url).hostname.replace(/^www\./, ""); } catch (_) { /* keep raw */ }

  return (
    <a
      href={url.startsWith("http") ? url : `https://${url}`}
      target="_blank"
      rel="noreferrer"
      className={`link-preview-card ${mine ? "mine" : ""}`}
    >
      {data.image ? <img src={data.image} alt="" className="link-preview-img" /> : null}
      <span className="link-preview-body">
        {data.title ? <span className="link-preview-title">{data.title}</span> : null}
        {data.description ? <span className="link-preview-desc">{data.description}</span> : null}
        <span className="link-preview-domain">{domain}</span>
      </span>
    </a>
  );
}
